import React, { useState } from "react";
import { Layout, Menu, Breadcrumb, Card, Upload } from "antd";
import {
  UserOutlined,
  LaptopOutlined,
  NotificationOutlined,
} from "@ant-design/icons";

import { Row, Col, Container, Alert } from "reactstrap";
import { Form, Input, Button } from "antd";

import AppLogic from "../../Logic/App/AppLogic";
import { Auth, Storage, Firestore } from "../../config/firebase";
import { Dropdown } from "semantic-ui-react";

import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import "filepond/dist/filepond.min.css";
registerPlugin(FilePondPluginImagePreview);

const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;

export default function NewAllproducts() {
  const [Title, setTitle] = useState("");
  const [Highlight, setHighlight] = useState("");
  const [Description, setDescription] = useState("");
  const [Focus_Area, setFocus] = useState("");
  const [Type, setType] = useState("");
  const [Apply, setwebapply] = useState("");

  const [Image, setImageAsUrl] = useState("");
  const [imageAsFile, setImageAsFile] = useState([]);

  const [antPics, setAntPics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [urls, setUrls] = useState([]);
  const [disable, setDisable] = useState(true);
  const [messageRes, setMessage] = useState("");
  const [error, setError] = useState("");

  const [files, setFiles] = useState([]);
  const [logo, setLogo] = useState([]);

  const onFinish = (values) => {
    console.log("Received values of form: ", values);
    const data = {
      Title,
      Highlight,
      Description,
      Focus_Area,
      Type,
      Apply,
      Image,
      imageAsFile,
      createdAt: Date.now()
    };

    if (!data) {
      setError("Fill Form Correctly");
      setMessage("");
    } else {
      console.log(data);
      Firestore.collection("allProducts")
        .add(data)
        .then((res) => {
          setMessage("Updates successfully added");
        })
        .catch((error) => {
          throw error;
        });
    }
  };

  const handleOnChange = (e, data) => {
    console.log(data.value);
    setType(data.value);
    console.log("Type", Type);
  };

  const handleAnt = (e) => {
    console.log("file", e.file.originFileObj);

    setLoading(true);
    console.log("uploading...");
    AppLogic.saveImage(e.file.originFileObj).then((res) => setImageAsUrl(res));
  };

  const Upload = (fieldName, file, metadata, load, error, progress, abort) => {
    console.log(files);
  };

  const options = [
    { key: "Event", text: "Event", value: "Event" },
    { key: "Bounty", text: "Bounty", value: "Bounty" },
    { key: "Investor Focus", text: "Investor Focus", value: "Investor Focus" },
    { key: "Funding", text: "Funding", value: "Funding" },
    { key: "De-Fi", text: "De-Fi", value: "De-Fi" },
    { key: "Startup", text: "Startup", value: "Startup" },
    { key: "Launch", text: "Launch", value: "Launch" },
  ];

  return (
    <>
      <Container className="">
        {messageRes === "" ? "" : <Alert>{messageRes}</Alert>}
        {error === "" ? "" : <Alert color={"danger"}>{error}</Alert>}
        <Card>
          New Product
          <hr />
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Row>
              <Col md={6} lg={6} sm={12}>
                <label>Title</label>
                <Form.Item
                  name="Title"
                  rules={[
                    { required: true, message: "Please input your Title" },
                  ]}
                >
                  <Input
                    allowClear
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Title"
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={6} lg={6} sm={12}>
                <label>Highlight</label>
                <Form.Item
                  name="Highlight"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Highlight line",
                    },
                  ]}
                >
                  <Input
                    allowClear
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Highlight"
                    onChange={(e) => setHighlight(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={6} lg={6} sm={12}>
                <label>Description</label>
                <Form.Item
                  name="Description"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Description",
                    },
                  ]}
                >
                  <textarea
                    placeholder="Description"
                    className="form-control"
                    onChange={(e) => setDescription(e.target.value)}
                  ></textarea>
                </Form.Item>
              </Col>

              <Col md={6} lg={6} sm={12}>
                <label>Focus Area</label>
                <Form.Item
                  name="Focus Area"
                  rules={[
                    { required: true, message: "Please input your Focus Area" },
                  ]}
                >
                  <Input
                    allowClear
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Focus Area"
                    onChange={(e) => setFocus(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={6} lg={6} sm={12}>
                <label>Type</label>
                <Dropdown
                  placeholder="Type"
                  onChange={handleOnChange}
                  fluid
                  multiple
                  selection
                  options={options}
                />
              </Col>

              <Col md={6} lg={6} sm={12}>
                <label>Website Link</label>
                <Form.Item
                  name="Link"
                  rules={[
                    {
                      required: true,
                      message: "Please input your website Link",
                    },
                  ]}
                >
                  <Input
                    allowClear
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Website Link"
                    onChange={(e) => setwebapply(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={12} lg={12}>
                <hr />
              </Col>

              <Col md={6} lg={6} sm={12}>
                <label>Logo</label>
                <Form.Item
                  rules={[{ required: true, message: "Please add your logo" }]}
                >
                  <FilePond
                    files={logo}
                    allowMultiple={false}
                    onupdatefiles={setLogo}
                    server={{
                      process: (
                        _fieldName,
                        file,
                        _metadata,
                        load,
                        error,
                        progress,
                        _abort
                      ) => {
                        AppLogic.saveImage(file).then((res) => {
                          setImageAsFile((url) => [...url, res], load(res));
                        });
                      },
                    }}
                    labelIdle='Drag &amp; Drop your files or <span class="filepond--label-action">Browse</span>'
                  />
                </Form.Item>
              </Col>

              <Col md={6} lg={6} sm={12}>
                <label>Website images</label>
                <Form.Item
                  rules={[
                    { required: true, message: "Please input your color tag" },
                  ]}
                >
                  <FilePond
                    files={files}
                    allowMultiple={true}
                    onupdatefiles={setFiles}
                    server={{
                      process: (
                        _fieldName,
                        file,
                        _metadata,
                        load,
                        error,
                        progress,
                        _abort
                      ) => {
                        AppLogic.saveImage(file).then((res) => {
                          setImageAsUrl((url) => [...url, res], load(res));
                        });
                      },
                    }}
                    labelIdle='Drag &amp; Drop your files or <span class="filepond--label-action">Browse</span>'
                  />
                </Form.Item>
              </Col>

              <Col md={12} lg={12} sm={12} className="text-right">
                <Button htmlType="submit">Save</Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </Container>
    </>
  );
}
